import React, { useId, useRef, useState } from "react";
import "./editable-combobox.css";

export function EditableCombobox({ value, onChange, options, ariaLabel }) {
  const [open, setOpen] = useState(false);
  const listboxId = useId();
  const rootRef = useRef(null);
  return (
    <div
      className="editable-combobox"
      ref={rootRef}
      onBlur={(event) => {
        if (!rootRef.current?.contains(event.relatedTarget)) setOpen(false);
      }}
    >
      <input
        aria-label={ariaLabel}
        aria-autocomplete="list"
        aria-controls={listboxId}
        aria-expanded={open}
        role="combobox"
        value={value}
        onChange={(event) => {
          onChange(event.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
      />
      <button
        aria-label={`Desplegar ${ariaLabel}`}
        aria-expanded={open}
        type="button"
        onClick={() => setOpen((current) => !current)}
      >
        ▾
      </button>
      {open && (
        <div className="editable-combobox-options" id={listboxId} role="listbox">
          {options.map((option) => (
            <button
              key={option}
              role="option"
              type="button"
              aria-selected={option === value}
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => {
                onChange(option);
                setOpen(false);
              }}
            >
              {option}
            </button>
          ))}
          {!options.includes(value) && value && (
            <span>Valor nuevo: se guardará tal como está escrito</span>
          )}
        </div>
      )}
    </div>
  );
}
